import { NextPage } from 'next'
import Head from 'next/head'

import getContentful from '@lib/contentful'
import processLegalPage, {
  LegalPageEntryI,
  RichTextI,
} from '@lib/contentful/entries/pages/legal'
import Page from '@components/page'
import RichTextModule from '@components/undock/modules/richText'
import UpsellModule from '@components/undock/modules/upsell'

export interface LegalPagePropsI {
  richText: RichTextI
  title: string
}

const LegalPage: NextPage<LegalPagePropsI> = ({
  richText = null,
  title = 'NO_TITLE_PROVIDED',
}) => {
  return (
    <Page lightHeader>
      <Head>
        <title>Undock | {title}</title>
      </Head>
      {richText && <RichTextModule {...richText} />}
      <UpsellModule
        ctaType="SIGN_UP"
        id="upsell"
        headline="Make time for what's important"
        themeName="dark"
        type="upsellModule"
      />
    </Page>
  )
}

export const getStaticPaths = async () => {
  return {
    paths: ['/l/legal/terms-of-service', '/l/legal/privacy-policy'],
    fallback: false,
  }
}

export const getStaticProps = async ({ params }) => {
  const { slug } = params
  const client = await getContentful()
  const entries = await client.getEntries<LegalPageEntryI>({
    content_type: 'legalPage',
    'fields.slug': slug,
    include: 10,
  })
  const entry = entries.items[0]
  const props = await processLegalPage(entry)

  return {
    props: {
      ...props,
    },
  }
}

export default LegalPage
